<template>
  <div class="nav" :class="{'nav-show':visible}" id="nav">
    <img src="https://summit-img.geekpark.net/nav-ifx.svg" style="width: 6.5vh" class="ifx" @click="scrollToTop">
    <div class="navs-container">
      <a href="#schedule">
        <img src="https://summit-img.geekpark.net/ifx/pc/%E4%B8%BB%E8%AE%BA%E5%9D%9B.svg" alt="">
      </a>
      <a href="#parallelForum">
        <img src="https://summit-img.geekpark.net/ifx/pc/%E5%B9%B3%E8%A1%8C%E8%AE%BA%E5%9D%9B.svg" alt="">
      </a>
      <a href="#museum">
        <img src="https://summit-img.geekpark.net/ifx/pc/%E7%89%B9%E5%88%AB%E5%B1%95.svg" alt="">
      </a>
      <a href="#stock-take">
        <img src="https://summit-img.geekpark.net/%E5%A5%96%E9%A1%B9.svg" alt="">
      </a>
      <a href="#partners">
        <img src="https://summit-img.geekpark.net/ifx/pc/nav-%E5%90%88%E4%BD%9C%E4%BC%99%E4%BC%B4.svg" alt="">
      </a>
      <a href="#footer">
        <img src="https://summit-img.geekpark.net/%E8%81%94%E7%B3%BB%E6%88%91%E4%BB%AC.svg" alt="">
      </a>
      <!-- <a href="http://global.geekpark.net">
        <img src="https://summit-img.geekpark.net/ifx/pc/IFX-%E6%B5%B7%E5%A4%96%E7%AB%99.svg" alt="">
      </a> -->
    </div>
  </div>
</template>

<script>
export default {
  name: 'Nav',
  props: ['visible'],
  methods: {
    scrollToTop () {
      window.scrollTo({ 'behavior': 'smooth', 'top': 0 })
    }
  }
}
</script>

<style scoped lang="less">
  .nav {
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    align-items: center;
    box-sizing: border-box;
    padding: 5vh 0 3vh 0;
    width: 8.5vh;
    height: 100vh;
    position: fixed;
    left: -8.5vh;
    top: 0;
    border-right: 1px solid #9b9b9b;
    background: #fff;
    z-index: 2000;
    transition: all .5s;
  }

  .nav-show {
    left: 0;
  }

  .ifx:hover {
    cursor: pointer;
  }

  .navs-container {
    display: flex;
    flex-direction: column;

    a {
      display: block;
      padding: 1vh 0 .6vh 0;
      width: 2.3vh;

      &:not(:first-of-type) {
        border-top: 2px solid #ff3c00;
      }
    }

    img {
      width: 1.4vh;
    }
  }
</style>
